import type { CustomField } from '@libs/domain';
import type { RequestType } from '@libs/templates/mst';
import { MstRegistrationTmpl } from '@libs/templates/mst';
import type { PageProps } from '@ps-smart-cp/ppfw-client';
import { withRerender } from '@ps-smart-cp/ppfw-client';
import { useCustomFieldBasicSettings } from './hooks';
import { CustomMstRegistration } from './models';
import { fetchMst, register, update } from './repositories';
import { createCustomMstItemName, createCustomMstRegistrationFieldConfig } from './services';

function PageComponent({
  type,
  customFieldKey,
  ...restProps
}: PageProps & Pick<RequestType, 'type'> & Pick<CustomField['schema'], 'customFieldKey'>) {
  const customFieldSettings = useCustomFieldBasicSettings();
  const requestType =
    type === 'new'
      ? { type, registrationFunction: register(customFieldKey)() }
      : {
          type,
          updateFunction: update(customFieldKey)(),
          fetchFunction: fetchMst(customFieldKey)(),
        };

  return (
    <MstRegistrationTmpl
      mstName={createCustomMstItemName(customFieldKey, customFieldSettings)}
      initMst={CustomMstRegistration.init}
      items={createCustomMstRegistrationFieldConfig(customFieldKey, customFieldSettings)}
      {...requestType}
      {...restProps}
    />
  );
}

const Registration = withRerender(PageComponent, 'Registration');

export { Registration };
